function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function E(n) {
  return n && n.__esModule ? n.default : n;
}
var v = /*#__PURE__*/function () {
  function v() {
    _classCallCheck(this, v);
  }
  return _createClass(v, [{
    key: "on",
    value: function on(e, i) {
      return this._callbacks = this._callbacks || {}, this._callbacks[e] || (this._callbacks[e] = []), this._callbacks[e].push(i), this;
    }
  }, {
    key: "emit",
    value: function emit(e) {
      this._callbacks = this._callbacks || {};
      var t = this._callbacks[e];
      for (var _len = arguments.length, i = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        i[_key - 1] = arguments[_key];
      }
      if (t) {
        var _iterator = _createForOfIteratorHelper(t),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var s = _step.value;
            s.apply(this, i);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return this.element && this.element.dispatchEvent(this.makeEvent("dropzone:" + e, {
        args: i
      })), this;
    }
  }, {
    key: "makeEvent",
    value: function makeEvent(e, i) {
      var t = {
        bubbles: !0,
        cancelable: !0,
        detail: i
      };
      if (typeof window.CustomEvent == "function") return new CustomEvent(e, t);
      var s = document.createEvent("CustomEvent");
      return s.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), s;
    }
  }, {
    key: "off",
    value: function off(e, i) {
      if (!this._callbacks || arguments.length === 0) return this._callbacks = {}, this;
      var t = this._callbacks[e];
      if (!t) return this;
      if (arguments.length === 1) return delete this._callbacks[e], this;
      for (var s = 0; s < t.length; s++) if (t[s] === i) {
        t.splice(s, 1);
        break;
      }
      return this;
    }
  }]);
}();
var F = {};
F = "<html><head></head><body><div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail=\"\"></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size=\"\"></span></div>\n    <div class=\"dz-filename\"><span data-dz-name=\"\"></span></div>\n  </div>\n  <div class=\"dz-progress\">\n    <span class=\"dz-upload\" data-dz-uploadprogress=\"\"></span>\n  </div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage=\"\"></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54\" height=\"54\" viewBox=\"0 0 54 54\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M10.2071 29.7929L14.2929 25.7071C14.6834 25.3166 15.3166 25.3166 15.7071 25.7071L21.2929 31.2929C21.6834 31.6834 22.3166 31.6834 22.7071 31.2929L38.2929 15.7071C38.6834 15.3166 39.3166 15.3166 39.7071 15.7071L43.7929 19.7929C44.1834 20.1834 44.1834 20.8166 43.7929 21.2071L22.7071 42.2929C22.3166 42.6834 21.6834 42.6834 21.2929 42.2929L10.2071 31.2071C9.81658 30.8166 9.81658 30.1834 10.2071 29.7929Z\"></path>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54\" height=\"54\" viewBox=\"0 0 54 54\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M26.2929 20.2929L19.2071 13.2071C18.8166 12.8166 18.1834 12.8166 17.7929 13.2071L13.2071 17.7929C12.8166 18.1834 12.8166 18.8166 13.2071 19.2071L20.2929 26.2929C20.6834 26.6834 20.6834 27.3166 20.2929 27.7071L13.2071 34.7929C12.8166 35.1834 12.8166 35.8166 13.2071 36.2071L17.7929 40.7929C18.1834 41.1834 18.8166 41.1834 19.2071 40.7929L26.2929 33.7071C26.6834 33.3166 27.3166 33.3166 27.7071 33.7071L34.7929 40.7929C35.1834 41.1834 35.8166 41.1834 36.2071 40.7929L40.7929 36.2071C41.1834 35.8166 41.1834 35.1834 40.7929 34.7929L33.7071 27.7071C33.3166 27.3166 33.3166 26.6834 33.7071 26.2929L40.7929 19.2071C41.1834 18.8166 41.1834 18.1834 40.7929 17.7929L36.2071 13.2071C35.8166 12.8166 35.1834 12.8166 34.7929 13.2071L27.7071 20.2929C27.3166 20.6834 26.6834 20.6834 26.2929 20.2929Z\"></path>\n    </svg>\n  </div>\n</div>\n</body></html>";
var C = {
  url: null,
  method: "post",
  withCredentials: !1,
  timeout: null,
  parallelUploads: 2,
  uploadMultiple: !1,
  chunking: !1,
  forceChunking: !1,
  chunkSize: 2097152,
  parallelChunkUploads: !1,
  retryChunks: !1,
  retryChunksLimit: 3,
  maxFilesize: 256,
  paramName: "file",
  createImageThumbnails: !0,
  maxThumbnailFilesize: 10,
  thumbnailWidth: 120,
  thumbnailHeight: 120,
  thumbnailMethod: "crop",
  resizeWidth: null,
  resizeHeight: null,
  resizeMimeType: null,
  resizeQuality: .8,
  resizeMethod: "contain",
  filesizeBase: 1e3,
  maxFiles: null,
  headers: null,
  defaultHeaders: !0,
  clickable: !0,
  ignoreHiddenFiles: !0,
  acceptedFiles: null,
  autoProcessQueue: !0,
  autoQueue: !0,
  addRemoveLinks: !1,
  previewsContainer: null,
  disablePreviews: !1,
  hiddenInputContainer: "body",
  capture: null,
  renameFilename: null,
  renameFile: null,
  forceFallback: !1,
  dictDefaultMessage: "Drop files here to upload",
  dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
  dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
  dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
  dictInvalidFileType: "You can't upload files of this type.",
  dictResponseError: "Server responded with {{statusCode}} code.",
  dictCancelUpload: "Cancel upload",
  dictUploadCanceled: "Upload canceled.",
  dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
  dictRemoveFile: "Remove file",
  dictRemoveFileConfirmation: null,
  dictMaxFilesExceeded: "You cannot upload any more files.",
  dictFileSizeUnits: {
    tb: "TB",
    gb: "GB",
    mb: "MB",
    kb: "KB",
    b: "b"
  },
  init: function init() {},
  params: function params(n, e, i) {
    if (i) return {
      dzuuid: i.file.upload.uuid,
      dzchunkindex: i.index,
      dztotalfilesize: i.file.size,
      dzchunksize: this.options.chunkSize,
      dztotalchunkcount: i.file.upload.totalChunkCount,
      dzchunkbyteoffset: i.index * this.options.chunkSize
    };
  },
  accept: function accept(n, e) {
    return e();
  },
  chunksUploaded: function chunksUploaded(n, e) {
    e();
  },
  binaryBody: !1,
  fallback: function fallback() {
    var n;
    this.element.className = "".concat(this.element.className, " dz-browser-not-supported");
    var _iterator2 = _createForOfIteratorHelper(this.element.getElementsByTagName("div")),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var i = _step2.value;
        if (/(^| )dz-message($| )/.test(i.className)) {
          n = i, i.className = "dz-message";
          break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    n || (n = r.createElement('<div class="dz-message"><span></span></div>'), this.element.appendChild(n));
    var e = n.getElementsByTagName("span")[0];
    return e && (e.textContent != null ? e.textContent = this.options.dictFallbackMessage : e.innerText != null && (e.innerText = this.options.dictFallbackMessage)), this.element.appendChild(this.getFallbackForm());
  },
  resize: function resize(n, e, i, t) {
    var s = {
        srcX: 0,
        srcY: 0,
        srcWidth: n.width,
        srcHeight: n.height
      },
      l = n.width / n.height;
    e == null && i == null ? (e = s.srcWidth, i = s.srcHeight) : e == null ? e = i * l : i == null && (i = e / l), e = Math.min(e, s.srcWidth), i = Math.min(i, s.srcHeight);
    var a = e / i;
    if (s.srcWidth > e || s.srcHeight > i) if (t === "crop") l > a ? (s.srcHeight = n.height, s.srcWidth = s.srcHeight * a) : (s.srcWidth = n.width, s.srcHeight = s.srcWidth / a);else if (t === "contain") l > a ? i = e / l : e = i * l;else throw new Error("Unknown resizeMethod '".concat(t, "'"));
    return s.srcX = (n.width - s.srcWidth) / 2, s.srcY = (n.height - s.srcHeight) / 2, s.trgWidth = e, s.trgHeight = i, s;
  },
  transformFile: function transformFile(n, e) {
    return (this.options.resizeWidth || this.options.resizeHeight) && n.type.match(/image.*/) ? this.resizeImage(n, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, e) : e(n);
  },
  previewTemplate: E(F),
  drop: function drop(n) {
    return this.element.classList.remove("dz-drag-hover");
  },
  dragstart: function dragstart(n) {},
  dragend: function dragend(n) {
    return this.element.classList.remove("dz-drag-hover");
  },
  dragenter: function dragenter(n) {
    return this.element.classList.add("dz-drag-hover");
  },
  dragover: function dragover(n) {
    return this.element.classList.add("dz-drag-hover");
  },
  dragleave: function dragleave(n) {
    return this.element.classList.remove("dz-drag-hover");
  },
  paste: function paste(n) {},
  reset: function reset() {
    return this.element.classList.remove("dz-started");
  },
  addedfile: function addedfile(n) {
    var _this = this;
    if (this.element === this.previewsContainer && this.element.classList.add("dz-started"), this.previewsContainer && !this.options.disablePreviews) {
      n.previewElement = r.createElement(this.options.previewTemplate.trim()), n.previewTemplate = n.previewElement, this.previewsContainer.appendChild(n.previewElement);
      var _iterator3 = _createForOfIteratorHelper(n.previewElement.querySelectorAll("[data-dz-name]")),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var e = _step3.value;
          e.textContent = n.name;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var _iterator4 = _createForOfIteratorHelper(n.previewElement.querySelectorAll("[data-dz-size]")),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          e = _step4.value;
          e.innerHTML = this.filesize(n.size);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.options.addRemoveLinks && (n._removeLink = r.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>".concat(this.options.dictRemoveFile, "</a>")), n.previewElement.appendChild(n._removeLink));
      var i = function i(t) {
        return t.preventDefault(), t.stopPropagation(), n.status === r.UPLOADING ? _this.options.dictCancelUploadConfirmation ? r.confirm(_this.options.dictCancelUploadConfirmation, function () {
          return _this.removeFile(n);
        }) : _this.removeFile(n) : _this.options.dictRemoveFileConfirmation ? r.confirm(_this.options.dictRemoveFileConfirmation, function () {
          return _this.removeFile(n);
        }) : _this.removeFile(n);
      };
      var _iterator5 = _createForOfIteratorHelper(n.previewElement.querySelectorAll("[data-dz-remove]")),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var t = _step5.value;
          t.addEventListener("click", i);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  },
  removedfile: function removedfile(n) {
    return n.previewElement != null && n.previewElement.parentNode != null && n.previewElement.parentNode.removeChild(n.previewElement), this._updateMaxFilesReachedClass();
  },
  thumbnail: function thumbnail(n, e) {
    if (n.previewElement) {
      n.previewElement.classList.remove("dz-file-preview");
      var _iterator6 = _createForOfIteratorHelper(n.previewElement.querySelectorAll("[data-dz-thumbnail]")),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var i = _step6.value;
          i.alt = n.name, i.src = e;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return setTimeout(function () {
        return n.previewElement.classList.add("dz-image-preview");
      }, 1);
    }
  },
  error: function error(n, e) {
    if (n.previewElement) {
      n.previewElement.classList.add("dz-error"), typeof e != "string" && e.error && (e = e.error);
      var _iterator7 = _createForOfIteratorHelper(n.previewElement.querySelectorAll("[data-dz-errormessage]")),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var i = _step7.value;
          i.textContent = e;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  },
  errormultiple: function errormultiple() {},
  processing: function processing(n) {
    if (n.previewElement && (n.previewElement.classList.add("dz-processing"), n._removeLink)) return n._removeLink.innerHTML = this.options.dictCancelUpload;
  },
  processingmultiple: function processingmultiple() {},
  uploadprogress: function uploadprogress(n, e, i) {
    if (n.previewElement) {
      var _iterator8 = _createForOfIteratorHelper(n.previewElement.querySelectorAll("[data-dz-uploadprogress]")),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var t = _step8.value;
          t.nodeName === "PROGRESS" ? t.value = e : t.style.width = "".concat(e, "%");
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  },
  totaluploadprogress: function totaluploadprogress() {},
  sending: function sending() {},
  sendingmultiple: function sendingmultiple() {},
  success: function success(n) {
    if (n.previewElement) return n.previewElement.classList.add("dz-success");
  },
  successmultiple: function successmultiple() {},
  canceled: function canceled(n) {
    return this.emit("error", n, this.options.dictUploadCanceled);
  },
  canceledmultiple: function canceledmultiple() {},
  complete: function complete(n) {
    if (n._removeLink && (n._removeLink.innerHTML = this.options.dictRemoveFile), n.previewElement) return n.previewElement.classList.add("dz-complete");
  },
  completemultiple: function completemultiple() {},
  maxfilesexceeded: function maxfilesexceeded() {},
  maxfilesreached: function maxfilesreached() {},
  queuecomplete: function queuecomplete() {},
  addedfiles: function addedfiles() {},
  emptyfolder: function emptyfolder() {}
};
var w = C;
var r = /*#__PURE__*/function (_v) {
  function r(e, i) {
    var _this2;
    _classCallCheck(this, r);
    _this2 = _callSuper(this, r);
    var t, s;
    if (_this2.element = e, _this2.clickableElements = [], _this2.listeners = [], _this2.files = [], typeof _this2.element == "string" && (_this2.element = document.querySelector(_this2.element)), _this2.element === null || !_this2.element instanceof HTMLElement) throw new Error("Invalid dropzone element: not an instance of HTMLElement.");
    if (_this2.element.dropzone) throw new Error("Dropzone already attached.");
    r.instances.push(_this2), _this2.element.dropzone = _this2;
    var l = (s = r.optionsForElement(_this2.element)) != null ? s : {};
    if (_this2.options = Object.assign({}, w, l, i !== null && i !== void 0 ? i : {}), _this2.options.previewTemplate = _this2.options.previewTemplate.replace(/\n*/g, ""), _this2.options.forceFallback || !r.isBrowserSupported()) return _possibleConstructorReturn(_this2, _this2.options.fallback.call(_this2));
    if (_this2.options.url == null && (_this2.options.url = _this2.element.getAttribute("action")), !_this2.options.url) throw new Error("No URL provided.");
    if (_this2.options.uploadMultiple && _this2.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
    if (_this2.options.binaryBody && _this2.options.uploadMultiple) throw new Error("You cannot set both: binaryBody and uploadMultiple.");
    typeof _this2.options.method == "string" && (_this2.options.method = _this2.options.method.toUpperCase()), (t = _this2.getExistingFallback()) && t.parentNode && t.parentNode.removeChild(t), _this2.options.previewsContainer !== !1 && (_this2.options.previewsContainer ? _this2.previewsContainer = r.getElement(_this2.options.previewsContainer, "previewsContainer") : _this2.previewsContainer = _this2.element), _this2.options.clickable && (_this2.options.clickable === !0 ? _this2.clickableElements = [_this2.element] : _this2.clickableElements = r.getElements(_this2.options.clickable, "clickable")), _this2.init();
    return _this2;
  }
  _inherits(r, _v);
  return _createClass(r, [{
    key: "getAcceptedFiles",
    value: function getAcceptedFiles() {
      return this.files.filter(function (e) {
        return e.accepted;
      }).map(function (e) {
        return e;
      });
    }
  }, {
    key: "getRejectedFiles",
    value: function getRejectedFiles() {
      return this.files.filter(function (e) {
        return !e.accepted;
      }).map(function (e) {
        return e;
      });
    }
  }, {
    key: "getFilesWithStatus",
    value: function getFilesWithStatus(e) {
      return this.files.filter(function (i) {
        return i.status === e;
      }).map(function (i) {
        return i;
      });
    }
  }, {
    key: "getQueuedFiles",
    value: function getQueuedFiles() {
      return this.getFilesWithStatus(r.QUEUED);
    }
  }, {
    key: "getUploadingFiles",
    value: function getUploadingFiles() {
      return this.getFilesWithStatus(r.UPLOADING);
    }
  }, {
    key: "getAddedFiles",
    value: function getAddedFiles() {
      return this.getFilesWithStatus(r.ADDED);
    }
  }, {
    key: "getActiveFiles",
    value: function getActiveFiles() {
      return this.files.filter(function (e) {
        return e.status === r.UPLOADING || e.status === r.QUEUED;
      }).map(function (e) {
        return e;
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      if (this.element.tagName === "form" && this.element.setAttribute("enctype", "multipart/form-data"), this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message") && this.element.appendChild(r.createElement("<div class=\"dz-default dz-message\"><button class=\"dz-button\" type=\"button\">".concat(this.options.dictDefaultMessage, "</button></div>"))), this.clickableElements.length) {
        var _t = function t() {
          var s;
          _this3.hiddenFileInput && ((s = _this3.hiddenFileInput.parentNode) == null || s.removeChild(_this3.hiddenFileInput)), _this3.hiddenFileInput = document.createElement("input"), _this3.hiddenFileInput.setAttribute("type", "file"), _this3.hiddenFileInput.setAttribute("form", _this3.element.id), (_this3.options.maxFiles === null || _this3.options.maxFiles > 1) && _this3.hiddenFileInput.setAttribute("multiple", "multiple"), _this3.hiddenFileInput.className = "dz-hidden-input", _this3.options.acceptedFiles !== null && _this3.hiddenFileInput.setAttribute("accept", _this3.options.acceptedFiles), _this3.options.capture !== null && _this3.hiddenFileInput.setAttribute("capture", _this3.options.capture), _this3.hiddenFileInput.setAttribute("tabindex", "-1"), _this3.hiddenFileInput.setAttribute("aria-label", "dropzone hidden input"), _this3.hiddenFileInput.style.visibility = "hidden", _this3.hiddenFileInput.style.position = "absolute", _this3.hiddenFileInput.style.top = "0", _this3.hiddenFileInput.style.left = "0", _this3.hiddenFileInput.style.height = "0", _this3.hiddenFileInput.style.width = "0", r.getElement(_this3.options.hiddenInputContainer, "hiddenInputContainer").appendChild(_this3.hiddenFileInput), _this3.hiddenFileInput.addEventListener("change", function () {
            var l = _this3.hiddenFileInput.files;
            if (l.length) {
              var _iterator9 = _createForOfIteratorHelper(l),
                _step9;
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var a = _step9.value;
                  _this3.addFile(a);
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            }
            _this3.emit("addedfiles", l), _t();
          });
        };
        _t();
      }
      this.URL = window.URL !== null ? window.URL : window.webkitURL;
      var _iterator0 = _createForOfIteratorHelper(this.events),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var t = _step0.value;
          this.on(t, this.options[t]);
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      this.on("uploadprogress", function () {
        return _this3.updateTotalUploadProgress();
      }), this.on("removedfile", function () {
        return _this3.updateTotalUploadProgress();
      }), this.on("canceled", function (t) {
        return _this3.emit("complete", t);
      }), this.on("complete", function (t) {
        if (_this3.getAddedFiles().length === 0 && _this3.getUploadingFiles().length === 0 && _this3.getQueuedFiles().length === 0) return setTimeout(function () {
          return _this3.emit("queuecomplete");
        }, 0);
      });
      var e = function e(t) {
        return t.dataTransfer.types && t.dataTransfer.types.includes("Files");
      };
      var i = function i(t) {
        if (e(t)) return t.stopPropagation(), t.preventDefault();
      };
      return this.listeners = [{
        element: this.element,
        events: {
          dragstart: function dragstart(t) {
            return _this3.emit("dragstart", t);
          },
          dragenter: function dragenter(t) {
            return i(t), _this3.emit("dragenter", t);
          },
          dragover: function dragover(t) {
            var s = t.dataTransfer.effectAllowed;
            return t.dataTransfer.dropEffect = s === "move" || s === "linkMove" ? "move" : "copy", i(t), _this3.emit("dragover", t);
          },
          dragleave: function dragleave(t) {
            return _this3.emit("dragleave", t);
          },
          drop: function drop(t) {
            return i(t), _this3.drop(t);
          },
          dragend: function dragend(t) {
            return _this3.emit("dragend", t);
          }
        }
      }], this.clickableElements.forEach(function (t) {
        return _this3.listeners.push({
          element: t,
          events: {
            click: function click(s) {
              return (t !== _this3.element || s.target === _this3.element || r.elementInside(s.target, _this3.element.querySelector(".dz-message"))) && _this3.hiddenFileInput.click(), !0;
            }
          }
        });
      }), this.enable(), this.options.init.call(this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.disable(), this.removeAllFiles(!0), this.hiddenFileInput != null && this.hiddenFileInput.parentNode && (this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput), this.hiddenFileInput = null), delete this.element.dropzone, r.instances.splice(r.instances.indexOf(this), 1);
    }
  }, {
    key: "updateTotalUploadProgress",
    value: function updateTotalUploadProgress() {
      var e,
        i = 0,
        t = 0;
      if (this.getActiveFiles().length) {
        var _iterator1 = _createForOfIteratorHelper(this.getActiveFiles()),
          _step1;
        try {
          for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
            var l = _step1.value;
            i += l.upload.bytesSent, t += l.upload.total;
          }
        } catch (err) {
          _iterator1.e(err);
        } finally {
          _iterator1.f();
        }
        e = 100 * i / t;
      } else e = 100;
      return this.emit("totaluploadprogress", e, t, i);
    }
  }, {
    key: "_getParamName",
    value: function _getParamName(e) {
      return typeof this.options.paramName == "function" ? this.options.paramName(e) : "".concat(this.options.paramName).concat(this.options.uploadMultiple ? "[".concat(e, "]") : "");
    }
  }, {
    key: "_renameFile",
    value: function _renameFile(e) {
      var i = _objectSpread(_objectSpread({}, e), {}, {
        name: e.name.replace(/\u202F/g, " ")
      });
      return typeof this.options.renameFile != "function" ? i.name : this.options.renameFile(i);
    }
  }, {
    key: "getFallbackForm",
    value: function getFallbackForm() {
      var _i;
      var e, i;
      if (e = this.getExistingFallback()) return e;
      var t = '<div class="dz-fallback">';
      this.options.dictFallbackText && (t += "<p>".concat(this.options.dictFallbackText, "</p>")), t += "<input type=\"file\" name=\"".concat(this._getParamName(0), "\" ").concat(this.options.uploadMultiple ? 'multiple="multiple"' : void 0, " /><input type=\"submit\" value=\"Upload!\"></div>");
      var s = r.createElement(t);
      return this.element.tagName !== "FORM" ? (i = r.createElement("<form action=\"".concat(this.options.url, "\" enctype=\"multipart/form-data\" method=\"").concat(this.options.method, "\"></form>")), i.appendChild(s)) : (this.element.setAttribute("enctype", "multipart/form-data"), this.element.setAttribute("method", this.options.method)), (_i = i) !== null && _i !== void 0 ? _i : s;
    }
  }, {
    key: "getExistingFallback",
    value: function getExistingFallback() {
      var e = function e(t) {
        var _iterator10 = _createForOfIteratorHelper(t),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var s = _step10.value;
            if (/(^| )fallback($| )/.test(s.className)) return s;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      };
      for (var _i2 = 0, _arr = ["div", "form"]; _i2 < _arr.length; _i2++) {
        var t = _arr[_i2];
        var i;
        if (i = e(this.element.getElementsByTagName(t))) return i;
      }
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      return this.listeners.map(function (e) {
        return function () {
          var i = [];
          for (var t in e.events) {
            var s = e.events[t];
            i.push(e.element.addEventListener(t, s, !1));
          }
          return i;
        }();
      });
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      return this.listeners.map(function (e) {
        return function () {
          var i = [];
          for (var t in e.events) {
            var s = e.events[t];
            i.push(e.element.removeEventListener(t, s, !1));
          }
          return i;
        }();
      });
    }
  }, {
    key: "disable",
    value: function disable() {
      var _this4 = this;
      return this.clickableElements.forEach(function (e) {
        return e.classList.remove("dz-clickable");
      }), this.removeEventListeners(), this.disabled = !0, this.files.map(function (e) {
        return _this4.cancelUpload(e);
      });
    }
  }, {
    key: "enable",
    value: function enable() {
      return delete this.disabled, this.clickableElements.forEach(function (e) {
        return e.classList.add("dz-clickable");
      }), this.setupEventListeners();
    }
  }, {
    key: "filesize",
    value: function filesize(e) {
      var i = 0,
        t = "b";
      if (e > 0) {
        var s = ["tb", "gb", "mb", "kb", "b"];
        for (var l = 0; l < s.length; l++) {
          var a = s[l],
            u = Math.pow(this.options.filesizeBase, 4 - l) / 10;
          if (e >= u) {
            i = e / Math.pow(this.options.filesizeBase, 4 - l), t = a;
            break;
          }
        }
        i = Math.round(10 * i) / 10;
      }
      return "<strong>".concat(i, "</strong> ").concat(this.options.dictFileSizeUnits[t]);
    }
  }, {
    key: "_updateMaxFilesReachedClass",
    value: function _updateMaxFilesReachedClass() {
      return this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles ? (this.getAcceptedFiles().length === this.options.maxFiles && this.emit("maxfilesreached", this.files), this.element.classList.add("dz-max-files-reached")) : this.element.classList.remove("dz-max-files-reached");
    }
  }, {
    key: "drop",
    value: function drop(e) {
      if (!e.dataTransfer) return;
      this.emit("drop", e);
      var i = [];
      for (var t = 0; t < e.dataTransfer.files.length; t++) i[t] = e.dataTransfer.files[t];
      if (i.length) {
        var _t2 = e.dataTransfer.items;
        _t2 && _t2.length && _t2[0].webkitGetAsEntry != null ? this._addFilesFromItems(_t2) : this.handleFiles(i);
      }
      this.emit("addedfiles", i);
    }
  }, {
    key: "paste",
    value: function paste(e) {
      if (S(e != null ? e.clipboardData : void 0, function (t) {
        return t.items;
      }) == null) return;
      this.emit("paste", e);
      var i = e.clipboardData.items;
      if (i.length) return this._addFilesFromItems(i);
    }
  }, {
    key: "handleFiles",
    value: function handleFiles(e) {
      var _iterator11 = _createForOfIteratorHelper(e),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var i = _step11.value;
          this.addFile(i);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "_addFilesFromItems",
    value: function _addFilesFromItems(e) {
      var _this5 = this;
      return function () {
        var i = [];
        var _iterator12 = _createForOfIteratorHelper(e),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var s = _step12.value;
            var t;
            s.webkitGetAsEntry != null && (t = s.webkitGetAsEntry()) ? t.isFile ? i.push(_this5.addFile(s.getAsFile())) : t.isDirectory ? i.push(_this5._addFilesFromDirectory(t, t.name)) : i.push(void 0) : s.getAsFile != null && (s.kind == null || s.kind === "file") ? i.push(_this5.addFile(s.getAsFile())) : i.push(void 0);
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        return i;
      }();
    }
  }, {
    key: "_addFilesFromDirectory",
    value: function _addFilesFromDirectory(e, i) {
      var _this6 = this;
      var t = e.createReader(),
        s = function s(u) {
          return T(console, "log", function (d) {
            return d.log(u);
          });
        },
        l = 0;
      var _a = function a() {
        return t.readEntries(function (u) {
          if (u.length > 0) {
            var _iterator13 = _createForOfIteratorHelper(u),
              _step13;
            try {
              for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                var d = _step13.value;
                d.isFile ? (++l, d.file(function (o) {
                  if (!(_this6.options.ignoreHiddenFiles && o.name.substring(0, 1) === ".")) return o.fullPath = "".concat(i, "/").concat(o.name), _this6.addFile(o);
                })) : d.isDirectory && _this6._addFilesFromDirectory(d, "".concat(i, "/").concat(d.name));
              }
            } catch (err) {
              _iterator13.e(err);
            } finally {
              _iterator13.f();
            }
            _a();
          } else l === 0 && _this6.emit("emptyfolder", i);
          return null;
        }, s);
      };
      return _a();
    }
  }, {
    key: "accept",
    value: function accept(e, i) {
      this.options.maxFilesize && e.size > this.options.maxFilesize * 1048576 ? i(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(e.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize)) : r.isValidFile(e, this.options.acceptedFiles) ? this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles ? (i(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles)), this.emit("maxfilesexceeded", e)) : this.options.accept.call(this, e, i) : i(this.options.dictInvalidFileType);
    }
  }, {
    key: "addFile",
    value: function addFile(e) {
      var _this7 = this;
      e.upload = {
        uuid: window.isSecureContext ? self.crypto.randomUUID() : r.uuidv4(),
        progress: 0,
        total: e.size,
        bytesSent: 0,
        filename: this._renameFile(e)
      }, this.files.push(e), e.status = r.ADDED, this.emit("addedfile", e), this._enqueueThumbnail(e), this.accept(e, function (i) {
        i ? (e.accepted = !1, _this7._errorProcessing([e], i)) : (e.accepted = !0, _this7.options.autoQueue && _this7.enqueueFile(e)), _this7._updateMaxFilesReachedClass();
      });
    }
  }, {
    key: "enqueueFiles",
    value: function enqueueFiles(e) {
      var _iterator14 = _createForOfIteratorHelper(e),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var i = _step14.value;
          this.enqueueFile(i);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      return null;
    }
  }, {
    key: "enqueueFile",
    value: function enqueueFile(e) {
      var _this8 = this;
      if (e.status === r.ADDED && e.accepted === !0) {
        if (e.status = r.QUEUED, this.options.autoProcessQueue) return setTimeout(function () {
          return _this8.processQueue();
        }, 0);
      } else throw new Error("This file can't be queued because it has already been processed or was rejected.");
    }
  }, {
    key: "_enqueueThumbnail",
    value: function _enqueueThumbnail(e) {
      var _this9 = this;
      if (this.options.createImageThumbnails && e.type.match(/image.*/) && e.size <= this.options.maxThumbnailFilesize * 1048576) return this._thumbnailQueue.push(e), setTimeout(function () {
        return _this9._processThumbnailQueue();
      }, 0);
    }
  }, {
    key: "_processThumbnailQueue",
    value: function _processThumbnailQueue() {
      var _this0 = this;
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) return;
      this._processingThumbnail = !0;
      var e = this._thumbnailQueue.shift();
      return this.createThumbnail(e, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, !0, function (i) {
        return _this0.emit("thumbnail", e, i), _this0._processingThumbnail = !1, _this0._processThumbnailQueue();
      });
    }
  }, {
    key: "removeFile",
    value: function removeFile(e) {
      if (e.status === r.UPLOADING && this.cancelUpload(e), this.files = k(this.files, e), this.emit("removedfile", e), this.files.length === 0) return this.emit("reset");
    }
  }, {
    key: "removeAllFiles",
    value: function removeAllFiles(e) {
      e == null && (e = !1);
      var _iterator15 = _createForOfIteratorHelper(this.files.slice()),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var i = _step15.value;
          (i.status !== r.UPLOADING || e) && this.removeFile(i);
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return null;
    }
  }, {
    key: "resizeImage",
    value: function resizeImage(e, i, t, s, l) {
      var _this1 = this;
      return this.createThumbnail(e, i, t, s, !0, function (a, u) {
        if (u == null) return l(e);
        {
          var d = _this1.options.resizeMimeType;
          d == null && (d = e.type);
          var o = u.toDataURL(d, _this1.options.resizeQuality);
          return (d === "image/jpeg" || d === "image/jpg") && (o = A(e.dataURL, o)), l(r.dataURItoBlob(o));
        }
      }, !0);
    }
  }, {
    key: "createThumbnail",
    value: function createThumbnail(e, i, t, s, l, a) {
      var _this10 = this;
      var u = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
      var d = new FileReader();
      d.onload = function () {
        if (e.dataURL = d.result, e.type === "image/svg+xml") {
          a != null && a(d.result);
          return;
        }
        _this10.createThumbnailFromUrl(e, i, t, s, l, a, void 0, u);
      }, d.readAsDataURL(e);
    }
  }, {
    key: "displayExistingFile",
    value: function displayExistingFile(e, i, t, s) {
      var _this11 = this;
      var l = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
      if (this.emit("addedfile", e), this.emit("complete", e), !l) this.emit("thumbnail", e, i), t && t();else {
        var a = function a(u) {
          _this11.emit("thumbnail", e, u), t && t();
        };
        e.dataURL = i, this.createThumbnailFromUrl(e, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, this.options.fixOrientation, a, s);
      }
    }
  }, {
    key: "createThumbnailFromUrl",
    value: function createThumbnailFromUrl(e, i, t, s, l, a, u) {
      var _this12 = this;
      var d = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : !1;
      var o = document.createElement("img");
      u && (o.crossOrigin = u), l = getComputedStyle(document.body).imageOrientation == "from-image" ? !1 : l, o.onload = function () {
        var g = function g(f) {
          return f(1);
        };
        return (typeof EXIF === "undefined" ? "undefined" : _typeof(EXIF)) < "u" && EXIF !== null && l && (g = function g(f) {
          return EXIF.getData(o, function () {
            return f(EXIF.getTag(this, "Orientation"));
          });
        }), g(function (f) {
          e.width = o.width, e.height = o.height;
          var p = _this12.options.resize.call(_this12, e, i, t, s),
            m = document.createElement("canvas"),
            c = m.getContext("2d");
          switch (m.width = p.trgWidth, m.height = p.trgHeight, f > 4 && (m.width = p.trgHeight, m.height = p.trgWidth), f) {
            case 2:
              c.translate(m.width, 0), c.scale(-1, 1);
              break;
            case 3:
              c.translate(m.width, m.height), c.rotate(Math.PI);
              break;
            case 4:
              c.translate(0, m.height), c.scale(1, -1);
              break;
            case 5:
              c.rotate(.5 * Math.PI), c.scale(1, -1);
              break;
            case 6:
              c.rotate(.5 * Math.PI), c.translate(0, -m.width);
              break;
            case 7:
              c.rotate(.5 * Math.PI), c.translate(m.height, -m.width), c.scale(-1, 1);
              break;
            case 8:
              c.rotate(-.5 * Math.PI), c.translate(-m.height, 0);
              break;
          }
          L(c, o, p.srcX != null ? p.srcX : 0, p.srcY != null ? p.srcY : 0, p.srcWidth, p.srcHeight, p.trgX != null ? p.trgX : 0, p.trgY != null ? p.trgY : 0, p.trgWidth, p.trgHeight);
          var y = m.toDataURL("image/png");
          if (a != null) return a(y, m);
        });
      }, a != null && (o.onerror = a);
      var h = e.dataURL;
      return d && (h = U(h)), o.src = h;
    }
  }, {
    key: "processQueue",
    value: function processQueue() {
      var e = this.options.parallelUploads,
        i = this.getUploadingFiles().length,
        t = i;
      if (i >= e) return;
      var s = this.getQueuedFiles();
      if (s.length > 0) {
        if (this.options.uploadMultiple) return this.processFiles(s.slice(0, e - i));
        for (; t < e;) {
          if (!s.length) return;
          this.processFile(s.shift()), t++;
        }
      }
    }
  }, {
    key: "processFile",
    value: function processFile(e) {
      return this.processFiles([e]);
    }
  }, {
    key: "processFiles",
    value: function processFiles(e) {
      var _iterator16 = _createForOfIteratorHelper(e),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var i = _step16.value;
          i.processing = !0, i.status = r.UPLOADING, this.emit("processing", i);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      return this.options.uploadMultiple && this.emit("processingmultiple", e), this.uploadFiles(e);
    }
  }, {
    key: "_getFilesWithXhr",
    value: function _getFilesWithXhr(e) {
      return this.files.filter(function (i) {
        return i.xhr === e;
      }).map(function (i) {
        return i;
      });
    }
  }, {
    key: "cancelUpload",
    value: function cancelUpload(e) {
      if (e.status === r.UPLOADING) {
        var i = this._getFilesWithXhr(e.xhr);
        var _iterator17 = _createForOfIteratorHelper(i),
          _step17;
        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var t = _step17.value;
            t.status = r.CANCELED;
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
        _typeof(e.xhr) < "u" && e.xhr.abort();
        var _iterator18 = _createForOfIteratorHelper(i),
          _step18;
        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var _t3 = _step18.value;
            this.emit("canceled", _t3);
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
        this.options.uploadMultiple && this.emit("canceledmultiple", i);
      } else (e.status === r.ADDED || e.status === r.QUEUED) && (e.status = r.CANCELED, this.emit("canceled", e), this.options.uploadMultiple && this.emit("canceledmultiple", [e]));
      if (this.options.autoProcessQueue) return this.processQueue();
    }
  }, {
    key: "resolveOption",
    value: function resolveOption(e) {
      for (var _len2 = arguments.length, i = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        i[_key2 - 1] = arguments[_key2];
      }
      return typeof e == "function" ? e.apply(this, i) : e;
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(e) {
      return this.uploadFiles([e]);
    }
  }, {
    key: "uploadFiles",
    value: function uploadFiles(e) {
      var _this13 = this;
      this._transformFiles(e, function (i) {
        if (_this13.options.chunking) {
          var t = i[0];
          e[0].upload.chunked = _this13.options.chunking && (_this13.options.forceChunking || t.size > _this13.options.chunkSize), e[0].upload.totalChunkCount = Math.ceil(t.size / _this13.options.chunkSize), t.size === 0 && (e[0].upload.totalChunkCount = 1);
        }
        if (e[0].upload.chunked) {
          var _t4 = e[0],
            s = i[0];
          _t4.upload.chunks = [];
          var l = function l() {
            var a = 0;
            for (; _t4.upload.chunks[a] !== void 0;) a++;
            if (a >= _t4.upload.totalChunkCount) return;
            var u = a * _this13.options.chunkSize,
              d = Math.min(u + _this13.options.chunkSize, s.size),
              o = {
                name: _this13._getParamName(0),
                data: s.webkitSlice ? s.webkitSlice(u, d) : s.slice(u, d),
                filename: _t4.upload.filename,
                chunkIndex: a
              };
            _t4.upload.chunks[a] = {
              file: _t4,
              index: a,
              dataBlock: o,
              status: r.UPLOADING,
              progress: 0,
              retries: 0
            }, _this13._uploadData(e, [o]);
          };
          if (_t4.upload.finishedChunkUpload = function (a, u) {
            var d = !0;
            a.status = r.SUCCESS, a.dataBlock = null, a.response = a.xhr.responseText, a.responseHeaders = a.xhr.getAllResponseHeaders(), a.xhr = null;
            for (var o = 0; o < _t4.upload.totalChunkCount; o++) {
              if (_t4.upload.chunks[o] === void 0) return l();
              _t4.upload.chunks[o].status !== r.SUCCESS && (d = !1);
            }
            d && _this13.options.chunksUploaded(_t4, function () {
              _this13._finished(e, u, null);
            });
          }, _this13.options.parallelChunkUploads) {
            var a = Math.min(_this13.options.parallelChunkUploads === !0 ? _this13.options.parallelUploads : _this13.options.parallelChunkUploads, _t4.upload.totalChunkCount);
            for (var u = 0; u < a; u++) l();
          } else l();
        } else {
          var _t5 = [];
          for (var _s = 0; _s < e.length; _s++) _t5[_s] = {
            name: _this13._getParamName(_s),
            data: i[_s],
            filename: e[_s].upload.filename
          };
          _this13._uploadData(e, _t5);
        }
      });
    }
  }, {
    key: "_getChunk",
    value: function _getChunk(e, i) {
      for (var t = 0; t < e.upload.totalChunkCount; t++) if (e.upload.chunks[t] !== void 0 && e.upload.chunks[t].xhr === i) return e.upload.chunks[t];
    }
  }, {
    key: "_uploadData",
    value: function _uploadData(e, i) {
      var _this14 = this;
      var t = new XMLHttpRequest();
      var _iterator19 = _createForOfIteratorHelper(e),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _o3 = _step19.value;
          _o3.xhr = t;
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      e[0].upload.chunked && (e[0].upload.chunks[i[0].chunkIndex].xhr = t);
      var s = this.resolveOption(this.options.method, e, i),
        l = this.resolveOption(this.options.url, e, i);
      t.open(s, l, !0), this.resolveOption(this.options.timeout, e) && (t.timeout = this.resolveOption(this.options.timeout, e)), t.withCredentials = !!this.options.withCredentials, t.onload = function (o) {
        _this14._finishedUploading(e, t, o);
      }, t.ontimeout = function () {
        _this14._handleUploadError(e, t, "Request timedout after ".concat(_this14.options.timeout / 1e3, " seconds"));
      }, t.onerror = function () {
        _this14._handleUploadError(e, t);
      };
      var u = t.upload != null ? t.upload : t;
      u.onprogress = function (o) {
        return _this14._updateFilesUploadProgress(e, t, o);
      };
      var d = this.options.defaultHeaders ? {
        Accept: "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      } : {};
      this.options.binaryBody && (d["Content-Type"] = e[0].type), this.options.headers && Object.assign(d, this.options.headers);
      for (var o in d) {
        var h = d[o];
        h && t.setRequestHeader(o, h);
      }
      if (this.options.binaryBody) {
        var _iterator20 = _createForOfIteratorHelper(e),
          _step20;
        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var _o = _step20.value;
            this.emit("sending", _o, t);
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
        this.options.uploadMultiple && this.emit("sendingmultiple", e, t), this.submitRequest(t, null, e);
      } else {
        var _o2 = new FormData();
        if (this.options.params) {
          var _h = this.options.params;
          typeof _h == "function" && (_h = _h.call(this, e, t, e[0].upload.chunked ? this._getChunk(e[0], t) : null));
          for (var g in _h) {
            var f = _h[g];
            if (Array.isArray(f)) for (var p = 0; p < f.length; p++) _o2.append(g, f[p]);else _o2.append(g, f);
          }
        }
        var _iterator21 = _createForOfIteratorHelper(e),
          _step21;
        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var _h3 = _step21.value;
            this.emit("sending", _h3, t, _o2);
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
        this.options.uploadMultiple && this.emit("sendingmultiple", e, t, _o2), this._addFormElementData(_o2);
        for (var _h2 = 0; _h2 < i.length; _h2++) {
          var _g = i[_h2];
          _o2.append(_g.name, _g.data, _g.filename);
        }
        this.submitRequest(t, _o2, e);
      }
    }
  }, {
    key: "_transformFiles",
    value: function _transformFiles(e, i) {
      var _this15 = this;
      var t = [],
        s = 0;
      var _loop = function _loop(l) {
        _this15.options.transformFile.call(_this15, e[l], function (a) {
          t[l] = a, ++s === e.length && i(t);
        });
      };
      for (var l = 0; l < e.length; l++) {
        _loop(l);
      }
    }
  }, {
    key: "_addFormElementData",
    value: function _addFormElementData(e) {
      if (this.element.tagName === "FORM") {
        var _iterator22 = _createForOfIteratorHelper(this.element.querySelectorAll("input, textarea, select, button")),
          _step22;
        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var i = _step22.value;
            var t = i.getAttribute("name"),
              s = i.getAttribute("type");
            if (s && (s = s.toLowerCase()), !(_typeof(t) > "u" || t === null)) if (i.tagName === "SELECT" && i.hasAttribute("multiple")) {
              var _iterator23 = _createForOfIteratorHelper(i.options),
                _step23;
              try {
                for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                  var l = _step23.value;
                  l.selected && e.append(t, l.value);
                }
              } catch (err) {
                _iterator23.e(err);
              } finally {
                _iterator23.f();
              }
            } else (!s || s !== "checkbox" && s !== "radio" || i.checked) && e.append(t, i.value);
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
      }
    }
  }, {
    key: "_updateFilesUploadProgress",
    value: function _updateFilesUploadProgress(e, i, t) {
      if (e[0].upload.chunked) {
        var s = e[0],
          l = this._getChunk(s, i);
        t ? (l.progress = 100 * t.loaded / t.total, l.total = t.total, l.bytesSent = t.loaded) : (l.progress = 100, l.bytesSent = l.total), s.upload.progress = 0, s.upload.total = 0, s.upload.bytesSent = 0;
        for (var a = 0; a < s.upload.totalChunkCount; a++) s.upload.chunks[a] && _typeof(s.upload.chunks[a].progress) < "u" && (s.upload.progress += s.upload.chunks[a].progress, s.upload.total += s.upload.chunks[a].total, s.upload.bytesSent += s.upload.chunks[a].bytesSent);
        s.upload.progress = s.upload.progress / s.upload.totalChunkCount, this.emit("uploadprogress", s, s.upload.progress, s.upload.bytesSent);
      } else {
        var _iterator24 = _createForOfIteratorHelper(e),
          _step24;
        try {
          for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
            var _s2 = _step24.value;
            _s2.upload.total && _s2.upload.bytesSent && _s2.upload.bytesSent == _s2.upload.total || (t ? (_s2.upload.progress = 100 * t.loaded / t.total, _s2.upload.total = t.total, _s2.upload.bytesSent = t.loaded) : (_s2.upload.progress = 100, _s2.upload.bytesSent = _s2.upload.total), this.emit("uploadprogress", _s2, _s2.upload.progress, _s2.upload.bytesSent));
          }
        } catch (err) {
          _iterator24.e(err);
        } finally {
          _iterator24.f();
        }
      }
    }
  }, {
    key: "_finishedUploading",
    value: function _finishedUploading(e, i, t) {
      var s;
      if (e[0].status !== r.CANCELED && i.readyState === 4) {
        if (i.responseType !== "arraybuffer" && i.responseType !== "blob" && (s = i.responseText, i.getResponseHeader("content-type") && ~i.getResponseHeader("content-type").indexOf("application/json"))) try {
          s = JSON.parse(s);
        } catch (l) {
          t = l, s = "Invalid JSON response from server.";
        }
        this._updateFilesUploadProgress(e, i), 200 <= i.status && i.status < 300 ? e[0].upload.chunked ? e[0].upload.finishedChunkUpload(this._getChunk(e[0], i), s) : this._finished(e, s, t) : this._handleUploadError(e, i, s);
      }
    }
  }, {
    key: "_handleUploadError",
    value: function _handleUploadError(e, i, t) {
      if (e[0].status !== r.CANCELED) {
        if (e[0].upload.chunked && this.options.retryChunks) {
          var s = this._getChunk(e[0], i);
          if (s.retries++ < this.options.retryChunksLimit) {
            this._uploadData(e, [s.dataBlock]);
            return;
          } else console.warn("Retried this chunk too often. Giving up.");
        }
        this._errorProcessing(e, t || this.options.dictResponseError.replace("{{statusCode}}", i.status), i);
      }
    }
  }, {
    key: "submitRequest",
    value: function submitRequest(e, i, t) {
      if (e.readyState != 1) {
        console.warn("Cannot send this request because the XMLHttpRequest.readyState is not OPENED.");
        return;
      }
      if (this.options.binaryBody) {
        if (t[0].upload.chunked) {
          var s = this._getChunk(t[0], e);
          e.send(s.dataBlock.data);
        } else e.send(t[0]);
      } else e.send(i);
    }
  }, {
    key: "_finished",
    value: function _finished(e, i, t) {
      var _iterator25 = _createForOfIteratorHelper(e),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var s = _step25.value;
          s.status = r.SUCCESS, this.emit("success", s, i, t), this.emit("complete", s);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      if (this.options.uploadMultiple && (this.emit("successmultiple", e, i, t), this.emit("completemultiple", e)), this.options.autoProcessQueue) return this.processQueue();
    }
  }, {
    key: "_errorProcessing",
    value: function _errorProcessing(e, i, t) {
      var _iterator26 = _createForOfIteratorHelper(e),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var s = _step26.value;
          s.status = r.ERROR, this.emit("error", s, i, t), this.emit("complete", s);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      if (this.options.uploadMultiple && (this.emit("errormultiple", e, i, t), this.emit("completemultiple", e)), this.options.autoProcessQueue) return this.processQueue();
    }
  }], [{
    key: "initClass",
    value: function initClass() {
      this.prototype.Emitter = v, this.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete", "emptyfolder"], this.prototype._thumbnailQueue = [], this.prototype._processingThumbnail = !1;
    }
  }, {
    key: "uuidv4",
    value: function uuidv4() {
      return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (e) {
        return (+e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +e / 4).toString(16);
      });
    }
  }]);
}(v);
r.initClass();
r.options = {};
r.optionsForElement = function (n) {
  if (n.getAttribute("id") && _typeof(r.options) < "u") return r.options[z(n.getAttribute("id"))];
};
r.instances = [];
r.forElement = function (n) {
  if (typeof n == "string" && (n = document.querySelector(n)), (n != null ? n.dropzone : void 0) == null) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
  return n.dropzone;
};
r.discover = function () {
  var n;
  if (document.querySelectorAll) n = document.querySelectorAll(".dropzone");else {
    n = [];
    var e = function e(i) {
      return function () {
        var t = [];
        var _iterator27 = _createForOfIteratorHelper(i),
          _step27;
        try {
          for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
            var s = _step27.value;
            /(^| )dropzone($| )/.test(s.className) ? t.push(n.push(s)) : t.push(void 0);
          }
        } catch (err) {
          _iterator27.e(err);
        } finally {
          _iterator27.f();
        }
        return t;
      }();
    };
    e(document.getElementsByTagName("div")), e(document.getElementsByTagName("form"));
  }
  return function () {
    var e = [];
    var _iterator28 = _createForOfIteratorHelper(n),
      _step28;
    try {
      for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
        var i = _step28.value;
        r.optionsForElement(i) !== !1 ? e.push(new r(i)) : e.push(void 0);
      }
    } catch (err) {
      _iterator28.e(err);
    } finally {
      _iterator28.f();
    }
    return e;
  }();
};
r.isBrowserSupported = function () {
  return (typeof Promise === "undefined" ? "undefined" : _typeof(Promise)) < "u";
};
r.dataURItoBlob = function (n) {
  var e = atob(n.split(",")[1]),
    i = n.split(",")[0].split(":")[1].split(";")[0],
    t = new ArrayBuffer(e.length),
    s = new Uint8Array(t);
  for (var l = 0, a = e.length, u = 0 <= a; u ? l <= a : l >= a; u ? l++ : l--) s[l] = e.charCodeAt(l);
  return new Blob([t], {
    type: i
  });
};
var k = function k(n, e) {
    return n.filter(function (i) {
      return i !== e;
    }).map(function (i) {
      return i;
    });
  },
  z = function z(n) {
    return n.replace(/[\-_](\w)/g, function (e) {
      return e.charAt(1).toUpperCase();
    });
  };
r.createElement = function (n) {
  var e = document.createElement("div");
  return e.innerHTML = n, e.childNodes[0];
};
r.elementInside = function (n, e) {
  if (n === e) return !0;
  for (; n = n.parentNode;) if (n === e) return !0;
  return !1;
};
r.getElement = function (n, e) {
  var i;
  if (typeof n == "string" ? i = document.querySelector(n) : n.nodeType != null && (i = n), i == null) throw new Error("Invalid `".concat(e, "` option provided. Please provide a CSS selector or a plain HTML element."));
  return i;
};
r.getElements = function (n, e) {
  var i, t;
  if (n instanceof Array) {
    t = [];
    try {
      var _iterator29 = _createForOfIteratorHelper(n),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          i = _step29.value;
          t.push(this.getElement(i, e));
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    } catch (_unused) {
      t = null;
    }
  } else if (typeof n == "string") {
    t = [];
    var _iterator30 = _createForOfIteratorHelper(document.querySelectorAll(n)),
      _step30;
    try {
      for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
        i = _step30.value;
        t.push(i);
      }
    } catch (err) {
      _iterator30.e(err);
    } finally {
      _iterator30.f();
    }
  } else n.nodeType != null && (t = [n]);
  if (t == null || !t.length) throw new Error("Invalid `".concat(e, "` option provided. Please provide a CSS selector, a plain HTML element or a list of those."));
  return t;
};
r.confirm = function (n, e, i) {
  if (window.confirm(n)) return e();
  if (i != null) return i();
};
r.isValidFile = function (n, e) {
  if (!e) return !0;
  e = e.split(",");
  var i = n.type,
    t = i.replace(/\/.*$/, "");
  var _iterator31 = _createForOfIteratorHelper(e),
    _step31;
  try {
    for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
      var s = _step31.value;
      if (s = s.trim(), s.charAt(0) === ".") {
        if (n.name.toLowerCase().indexOf(s.toLowerCase(), n.name.length - s.length) !== -1) return !0;
      } else if (/\/\*$/.test(s)) {
        if (t === s.replace(/\/.*$/, "")) return !0;
      } else if (i === s) return !0;
    }
  } catch (err) {
    _iterator31.e(err);
  } finally {
    _iterator31.f();
  }
  return !1;
};
(typeof jQuery === "undefined" ? "undefined" : _typeof(jQuery)) < "u" && jQuery !== null && (jQuery.fn.dropzone = function (n) {
  return this.each(function () {
    return new r(this, n);
  });
});
r.ADDED = "added";
r.QUEUED = "queued";
r.ACCEPTED = r.QUEUED;
r.UPLOADING = "uploading";
r.PROCESSING = r.UPLOADING;
r.CANCELED = "canceled";
r.ERROR = "error";
r.SUCCESS = "success";
var b = function b(n) {
  var e = n.naturalHeight,
    i = document.createElement("canvas");
  i.width = 1, i.height = e;
  var t = i.getContext("2d");
  t.drawImage(n, 0, 0);
  var _t$getImageData = t.getImageData(1, 0, 1, e),
    s = _t$getImageData.data,
    l = 0,
    a = e,
    u = e;
  for (; u > l;) s[(u - 1) * 4 + 3] === 0 ? a = u : l = u, u = a + l >> 1;
  var d = u / e;
  return d === 0 ? 1 : d;
};
var L = function L(n, e, i, t, s, l, a, u, d, o) {
  var h = b(e);
  return n.drawImage(e, i, t, s, l, a, u, d, o / h);
};
function U(n) {
  var e = "data:image/jpeg;base64,";
  if (!n.startsWith(e)) return n;
  var i = window.atob(n.slice(e.length));
  if (!i.startsWith("ÿØÿ")) return n;
  for (var t = 0, s = ""; t < i.length;) if (i.slice(t, t + 2) == "ÿÚ") {
    s += i.slice(t);
    break;
  } else if (i.slice(t, t + 2) == "ÿØ") s += i.slice(t, t + 2), t += 2;else {
    var l = i.charCodeAt(t + 2) * 256 + i.charCodeAt(t + 3),
      a = t + l + 2,
      u = i.slice(t, a);
    u.startsWith("ÿá") || (s += u), t = a;
  }
  return e + window.btoa(s);
}
function A(n, e) {
  var i = "data:image/jpeg;base64,";
  if (!(n.startsWith(i) && e.startsWith(i))) return e;
  var t = window.atob(n.slice(i.length));
  if (!t.startsWith("ÿØÿ")) return e;
  for (var s = 0, l = ""; s < t.length && t.slice(s, s + 2) != "ÿÚ";) if (t.slice(s, s + 2) == "ÿØ") s += 2;else {
    var a = t.charCodeAt(s + 2) * 256 + t.charCodeAt(s + 3),
      u = s + a + 2,
      d = t.slice(s, u);
    d.startsWith("ÿá") && (l += d), s = u;
  }
  if (l == "") return e;
  var o = window.atob(e.slice(i.length));
  if (!o.startsWith("ÿØÿ")) return e;
  var h = 4 + o.charCodeAt(4) * 256 + o.charCodeAt(5);
  return o = o.slice(0, h) + l + o.slice(h), i + window.btoa(o);
}
function S(n, e) {
  return _typeof(n) < "u" && n !== null ? e(n) : void 0;
}
function T(n, e, i) {
  if (_typeof(n) < "u" && n !== null && typeof n[e] == "function") return i(n, e);
}
export { r as Dropzone, r as default };